import axios from 'axios'
import { API_URL } from '@/const'
import { store } from '@/store'

export const getAxiosMessage = async (channel) => {
  const { accessToken } = store.state.app.user
  const headers = {
    Authorization: `Bearer ${accessToken}`
  }
  try {
    const { data } = await axios.get(`${API_URL.MESSAGES}/${channel}`, { headers })
    if (!data) return {}
    if (data.length === 0) return {}
    return data
  } catch (e) {
    console.log(e.response.data)
  }
  return {}
}
